import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { HcaMemberService } from '../../../shared/_services/hca-member.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MarketingService } from '../../../shared/_services/marketing.service';
import { UtilService } from '../../../shared/_services/util.service';

@Component({
  selector: 'app-add-transaction',
  templateUrl: './add-transaction.component.html',
  styleUrls: ['./add-transaction.component.scss']
})
export class AddTransactionComponent implements OnInit {
  memberId: any;
  transactionTypes: any[] = [];
  errorMsg: string;
  successMsg: string;
  transactionForm: FormGroup;
  srcObject: any = [];
  searchedBookings: any[] = [];
  searchedTransactions: any[] = [];
  transactionTerm$ = new Subject<string>();
  isRelatedTransError : boolean = false;
  isRelatedBookingError : boolean = false;
  bookingTerm$ = new Subject<string>();
  user: any;
  role: any;
  pointsTransTypeData: boolean  ;
  isRegularization: boolean = false;
  isReservation: boolean = false;
  constructor(
    private fb: FormBuilder,
    public bsModalRef: BsModalRef,
    private marketingService: MarketingService,
    private hcaMemberService: HcaMemberService,
    private utilService: UtilService,
  ) {
    this.hcaMemberService.search(this.transactionTerm$, this.memberId, 'transaction')
      .subscribe(res => {
        if(res.error == 0) {
          this.searchedTransactions = res.responseObj;
          if(this.searchedTransactions && this.searchedTransactions.length && this.searchedTransactions.indexOf(this.transactionForm.get('relatedTransactionId').value) == -1) {
            this.isRelatedTransError = true;
          } else {
            if(this.transactionForm.get('relatedTransactionId').value) {
              this.isRelatedTransError = true;
            } else {
              this.isRelatedTransError = false;
            }
          }
        }
      }, err => {
        this.searchedTransactions = [];
      });

    this.hcaMemberService.search(this.bookingTerm$, this.memberId, 'booking')
      .subscribe(res => {
        if(res.error == 0) {
          this.searchedBookings = res.responseObj;
          if(this.searchedBookings && this.searchedBookings.length && this.searchedBookings.indexOf(this.transactionForm.get('relatedBookingId').value) == -1) {
            this.isRelatedBookingError = true;
          } else {
            if(this.transactionForm.get('relatedBookingId').value) {
              this.isRelatedBookingError = true;
            } else {
              this.isRelatedBookingError = false;
            }
          }
        }
      }, err => {
        this.searchedTransactions = [];
      });
  }

  getTransactionTYpes() {
    this.marketingService.getTransactionTypes('member').subscribe(res=> {
      if(res.error == 0) {
        this.transactionTypes = res.responseObj;
      }
    }, err => {
      console.error('Error while getting transaction types: ', err.message);
    })
  }

  selectDropdown(id, type) {
    if(type == 'transaction') {
      this.transactionForm.get('relatedTransactionId').setValue(id);
      // setTimeout(() => {
        if(this.searchedTransactions.length) {
          // this.transactionForm.get('relatedTransactionId').value
          let transactionIds = this.searchedTransactions.map(transaction => transaction.pointTransactionId);
          if(transactionIds.indexOf(id) == -1) {
            this.isRelatedTransError = true;
          } else {
            this.isRelatedTransError = false;
          }
          console.log(this.transactionForm.get('relatedTransactionId').value);
        }
      // }, 100);
    } else {
      this.transactionForm.get('relatedBookingId').setValue(id);
      // setTimeout(() => {
        if(this.searchedBookings.length) {
          // this.transactionForm.get('relatedBookingId').value
          let bookingIds = this.searchedBookings.map(booking => booking.bookingId);
          if(bookingIds.indexOf(id) == -1) {
            this.isRelatedBookingError = true;
          } else {
            this.isRelatedBookingError = false;
          }
          console.log(this.transactionForm.get('relatedBookingId').value);
        }
      // }, 100);
    }

  }

  selectTransactionType(id) {
    if(id == 24) {
      this.isRegularization = true;
      this.isReservation = false;
      this.transactionForm.get('fiscalOrigin').enable()
    } else if (id == 1) {
      this.isReservation = true;
      this.isRegularization = false;
      this.transactionForm.get('fiscalOrigin').disable()
    } else {
      this.isReservation = false;
      this.isRegularization = false;
      this.transactionForm.get('fiscalOrigin').disable()
    }
  }

  save(isApprove) {
    console.log('adding new transaction with values: ', this.transactionForm.value);
    this.hcaMemberService.saveTransaction(this.transactionForm.value, isApprove).subscribe(res => {
      this.successMsg = 'Transaction saved successfully';
      setTimeout(() => {
        this.successMsg = '';
        this.srcObject.action = "action1";
        this.bsModalRef.hide();
      }, 1500);
    }, err => {
      console.error('Error while adding transaction for member: ', err.message);
      this.errorMsg = err.message ? err.message : 'Transaction could not be saved';
      setTimeout(() => {
        this.errorMsg = '';
      }, 1500);
    });
  }

  initForm(memberId?) {
    this.transactionForm = this.fb.group({
      memberId: [memberId ? parseInt(memberId) : null],
      pointsTransTypeId: [null, Validators.required],
      points: ['', Validators.compose([Validators.required, Validators.max(9999999999), Validators.pattern('^[-+]?[0-9]+$')])],
      description: ['', Validators.maxLength(1000)],
      relatedTransactionId: [null],
      relatedBookingId: [null],
      personType: [''],
      fiscalOrigin:[{value:'', disabled:true}, Validators.required],
      //pmsSurname1: [null, Validators.required]
    });
    this.pointsTransTypeData = true;
    this.transactionForm.get('pointsTransTypeId').valueChanges.subscribe(value => {
      if(value && value == 1) {
        this.transactionForm.get('points').setValue(0, { emitEvent: false });
        this.transactionForm.get('points').setValidators([Validators.required, Validators.min(0), Validators.max(9999999999), Validators.pattern('^[-+]?[0-9]+$')]);
        this.transactionForm.get('points').updateValueAndValidity();
        this.pointsTransTypeData = true;
      } else {
        this.transactionForm.get('points').setValue(null, { emitEvent: false });
        this.transactionForm.get('points').setValidators([Validators.required, Validators.max(9999999999), Validators.pattern('^[-+]?[0-9]+$')]);
        this.transactionForm.get('points').updateValueAndValidity();
      }
    });
    this.transactionForm.get('relatedTransactionId').valueChanges.subscribe(value => {
      console.log('=================== transaction ================');
      // console.log('searched transaction text: ', value);
      // console.log('searched transaction length: ', this.searchedTransactions);
      console.log('=================== transaction ================');
    });

    this.transactionForm.get('relatedBookingId').valueChanges.subscribe(value => {
      console.log('=================== booking ================');
      console.log('searched booking length: ', this.searchedBookings);
      console.log('searched booking text: ', value);
      console.log('=================== booking ================');
    });
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('loggedInUser'));
    this.role = this.utilService.parseJwt(this.user.token).info.roles;
    this.getTransactionTYpes();
    this.initForm();
    setTimeout(() => {
      if (this.memberId) {
        this.initForm(this.memberId);
      }
    }, 100);

  }

  closeModal(){
    this.bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/add-transaction/add-transaction.component.ts